
(function(m, k) {
    var p = function() {
        var c = this;
        this.mediaStVersion = "414";
        this.instance = [];
        this.mediaSessions = {};
        this.maxMediaRequests = 500;
        this.ignoreDuplicatedRequest = !0;
        this.ignoreDuplicatedRequestTimeout = 3E3;
        var f = function() {},
            p = function(a) {
                a = a.split("&");
                for (var b = "?", d = 0, c = a.length; c;) d = parseInt(Math.random() * c), b += a.splice(d, 1) + "&", c--;
                return b.substr(0, b.length - 1)
            },
            q = function() {
                for (var a = parseInt(10 * Math.random()) + 5, b = "", d = 0, c; d < a; d++) c = parseInt(37 * Math.random()), b += "abcdefghijklmnopqrstuvwxyz-_0123456789".charAt(c);
                return b
            };
        this.getPixelInstance = function(a, b) {
            if ("undefined" !== typeof webtrekkUnloadObjects)
                for (var d = 0, c = webtrekkUnloadObjects.length; d < c; d++) {
                    var e = webtrekkUnloadObjects[d];
                    if (e.trackId) {
                        "1" !== e.cookie || e.eid || e.firstParty();
                        "undefined" === typeof e.requestObfuscation && (e.requestObfuscation = !1);
                        "undefined" === typeof e.executePlugin && (e.executePlugin = f);
                        "undefined" === typeof e.getPluginConfig && (e.getPluginConfig = f);
                        if (e.trackId === a) return [e];
                        if (-1 !== e.trackId.indexOf(a)) return [{
                            trackDomain: b,
                            trackId: a,
                            eid: e.eid,
                            pixelSampling: e.pixelSampling,
                            deactivatePixel: e.deactivatePixel,
                            executePlugin: e.executePlugin,
                            getPluginConfig: e.getPluginConfig,
                            requestObfuscation: e.requestObfuscation
                        }]
                    }
                }
            return "undefined" !== typeof webtrekk && webtrekk.trackId && webtrekk.trackDomain ? (webtrekk.eid = "undefined" !== typeof wt_cookie_eid ? wt_cookie_eid : !1, webtrekk.deactivatePixel = "undefined" !== typeof wt_deactivatePixel ? wt_deactivatePixel : !1, webtrekk.requestObfuscation = !1, webtrekk.executePlugin = f, webtrekk.getPluginConfig = f, [webtrekk]) : []
        };
        this.getAllPixelInstances = function() {
            if ("undefined" !== typeof webtrekkUnloadObjects) {
                for (var a = 0, b = webtrekkUnloadObjects.length; a < b; a++) {
                    var d = webtrekkUnloadObjects[a];
                    "1" !== d.cookie || d.eid || d.firstParty();
                    "undefined" === typeof d.requestObfuscation && (d.requestObfuscation = !1);
                    "undefined" === typeof d.executePlugin && (d.executePlugin = f);
                    "undefined" === typeof d.getPluginConfig && (d.getPluginConfig = f)
                }
                return webtrekkUnloadObjects
            }
            return []
        };
        this.escape = function(a) {
            try {
                return encodeURIComponent(a)
            } catch (b) {
                return escape(a)
            }
        };
        this.getMediaCategory = function(a, b) {
            var d = "",
                g, e;
            for (e in b)
                if (g = e + "", a || -1 === g.indexOf("mg")) d += "&" + g + "=" + c.escape(b[g]);
            return d
        };
        this.init = function(a, b, d) {
            d = d ? d : 0;
            a && b && (c.instance = c.getPixelInstance(b, a), 0 >= c.instance.length && (a = {
                trackDomain: a,
                trackId: b,
                eid: !1,
                pixelSampling: d ? d : 0,
                deactivatePixel: !1,
                executePlugin: f,
                getPluginConfig: f,
                requestObfuscation: !1
            }, Math && (Math.random && 0 !== parseInt(Math.random() * parseInt(d))) && (a.deactivatePixel = !0), c.instance.push(a)))
        };
        this.getPositionInterval = function(a) {
            var b =
                "undefined" !== typeof wt_mediaInterval ? parseInt(wt_mediaInterval) : 60;
            return "0" === a ? 6E4 : 10 <= parseInt(a) / b ? 1E3 * (parseInt(a) / b) : 1E4
        };
        this.checkPositionTime = function(a) {
            a = c.mediaSessions[a];
            if (null === a.posTime) return a.posTime = (new Date).getTime(), !0;
            var b = (new Date).getTime();
            if (b - a.posTime < a.posInterval) return !1;
            a.posTime = b;
            return !0
        };
        this.checkMediaRequest = function(a, b, d) {
            if (!c.ignoreDuplicatedRequest) return !0;
            a = c.mediaSessions[a];
            b = b + "_" + d;
            if ("undefined" === typeof a.sendMediaRequest[b]) a.sendMediaRequest[b] =
                (new Date).getTime();
            else {
                d = (new Date).getTime();
                if (d - a.sendMediaRequest[b] <= c.ignoreDuplicatedRequestTimeout) return a.sendMediaRequest[b] = d, !1;
                a.sendMediaRequest[b] = d
            }
            return !0
        };
        this.initializeMediaSession = function(a, b, d) {
            "init" === d && "undefined" !== typeof c.mediaSessions[a] && delete c.mediaSessions[a];
            "undefined" === typeof c.mediaSessions[a] && (c.mediaSessions[a] = {
                posInterval: c.getPositionInterval(b),
                posTime: null,
                maxMediaRequests: "undefined" !== typeof wt_maxMediaRequests ? wt_maxMediaRequests : c.maxMediaRequests,
                sendMediaRequest: {}
            }, c.ignoreDuplicatedRequest = "undefined" !== typeof wt_ignoreDuplicatedRequest ? wt_ignoreDuplicatedRequest : !0, c.ignoreDuplicatedRequestTimeout = "undefined" !== typeof wt_ignoreDuplicatedRequestTimeout ? parseInt(wt_ignoreDuplicatedRequestTimeout) : 3E3)
        };
        this.sendinfo_media = function(a, b, d, g, e, n, l, h) {
            if (a && (0 >= c.instance.length && ("object" === typeof webtrekk && webtrekk.trackDomain && webtrekk.trackId ? c.init(webtrekk.trackDomain, webtrekk.trackId) : c.instance = c.getAllPixelInstances()), !(0 >= c.instance.length))) {
                if (!g ||
                    isNaN(parseInt(g))) g = "0";
                var f = "init" === b || "play" === b,
                    k = "";
                n = "&bw=" + (n ? n : "") + ("&vol=" + (l ? l : ""));
                n += "&mut=" + (h ? h : "");
                n += "&pu=" + c.escape(m.document.location.href.split("#")[0]);
                if (e)
                    if ("string" === typeof e) {
                        k = e.split(";");
                        e = {};
                        for (h = 0; h < k.length; h++) l = k[h].split("="), 2 <= l.length && (e[l[0]] = l[1]);
                        k = c.getMediaCategory(f, e)
                    } else "object" === typeof e && (k = c.getMediaCategory(f, e));
                c.initializeMediaSession(a, g, b);
                if (!("pos" === b && !c.checkPositionTime(a) || "pos" !== b && !c.checkMediaRequest(a, b, d) || 0 >= c.mediaSessions[a].maxMediaRequests &&
                        "eof" !== b && "stop" !== b))
                    for (c.mediaSessions[a].maxMediaRequests--, "eof" !== b && "stop" !== b || delete c.mediaSessions[a], f = 0; f < c.instance.length; f++) e = c.instance[f], e.deactivatePixel || (h = "st,1," + c.baseparams() + "&mi=" + c.escape(a) + "&mk=" + c.escape(b) + "&mt1=" + d + "&mt2=" + g, e.eid && (h += "&eid=" + e.eid), h += k, h += n, e.executePlugin(e.getPluginConfig("media", "before")), c.quicksend(e, h), e.executePlugin(e.getPluginConfig("media", "after")))
            }
        };
        this.quicksend = function(a, b) {
            if (!a.deactivatePixel) {
                var d = a.trackDomain,
                    g = a.trackId,
                    e = "wt";
                a.requestObfuscation && (e += q());
                b = "p=" + c.mediaStVersion + "," + b;
                var f = "https:" == location.protocol ? "https:" : "http:",
                    f = f + ("//" + d + "/" + g + "/" + e),
                    f = a.requestObfuscation ? f + p(b) : f + ("?" + b),
                    d = {};
                d.Image = "function" !== typeof m.Image ? function() {
                    return k.createElement("img")
                } : m.Image;
                if ("undefined" === typeof l) var l = [];
                g = l.length;
                l[g] = new d.Image;
                l[g].onload = function() {
                    return !1
                };
                l[g].src = f
            }
        };
        this.getBrowserHeight = function() {
            var a = 0;
            try {
                a = m.innerHeight
            } catch (b) {}
            if (!a) try {
                a = k.documentElement.clientHeight
            } catch (d) {}
            if (!a) try {
                a =
                    k.body.clientHeight
            } catch (c) {}
            "undefined" === typeof a && (a = -1);
            return a
        };
        this.getBrowserWidth = function() {
            var a = 0;
            try {
                a = m.innerWidth
            } catch (b) {}
            if (!a) try {
                a = k.documentElement.clientWidth
            } catch (d) {}
            if (!a) try {
                a = k.body.clientWidth
            } catch (c) {}
            "undefined" === typeof a && (a = -1);
            return a
        };
        this.baseparams = function() {
            var a = screen.width + "x" + screen.height + ",",
                a = a + (("Netscape" != navigator.appName ? screen.colorDepth : screen.pixelDepth) + ","),
                a = a + (navigator.cookieEnabled ? "1," : navigator.cookieEnabled ? -1 != k.cookie.indexOf("=") ?
                    "1," : "0," : "0,"),
                a = a + ((new Date).getTime() + ","),
                a = a + "1",
                b = c.getBrowserHeight(),
                d = c.getBrowserWidth();
            b && b > screen.height && (b = screen.height);
            d && d > screen.width && (d = screen.width);
            return a = a + ("," + d + "x" + b) + ("," + (navigator.javaEnabled() ? "1" : "0"))
        };
        m.wt_init_media = c.init;
        m.wt_sendinfo_media = c.sendinfo_media
    };
    "undefined" === typeof m.webtrekkMediaTracking && m.webtrekkMediaTracking instanceof p || (m.webtrekkMediaTracking = new p)
})(window, document);
